// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueResource from 'vue-resource'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/main.css'
import './assets/css/iconfont.css'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueResource)

Vue.http.interceptors.push((request, next) => {
  next((resp) => {
    if (resp.data.code == -150 && location.hash.indexOf("home/login") == -1) {
      alert("用户登录失效，请重新登录")
      // 登录失效
      location.href = "/"
    }
  });
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js